import { render, staticRenderFns } from "./AchievementExplanationBadge.vue?vue&type=template&id=dc6ac52c&scoped=true"
import script from "./AchievementExplanationBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementExplanationBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AchievementExplanationBadge.vue?vue&type=style&index=0&id=dc6ac52c&prod&scoped=true&lang=css"
import style1 from "./AchievementExplanationBadge.vue?vue&type=style&index=1&id=dc6ac52c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6ac52c",
  null
  
)

export default component.exports